import { render, staticRenderFns } from "./Corresponsalia-ticketsUSD.vue?vue&type=template&id=67dcdd75&scoped=true&"
import script from "./Corresponsalia-ticketsUSD.vue?vue&type=script&lang=js&"
export * from "./Corresponsalia-ticketsUSD.vue?vue&type=script&lang=js&"
import style0 from "./Corresponsalia-ticketsUSD.vue?vue&type=style&index=0&id=67dcdd75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcdd75",
  null
  
)

export default component.exports